export const ACCEPTABLE_POSITION_RECORD_TYPES = [
  'federal_bill', 'state_bill', 'federal_regulation', 'state_regulation',
];
